module.exports = __webpack_public_path__ + "static/media/BizTech1.ffa77943.jpg";